import { useState, useCallback } from 'react';
import { testimonials } from '@/mocks/testimonials';

export default function TestimonialSection() {
  const [currentIndex, setCurrentIndex] = useState(0);

  const prev = useCallback(() => {
    setCurrentIndex((i) => (i === 0 ? testimonials.length - 1 : i - 1));
  }, []);

  const next = useCallback(() => {
    setCurrentIndex((i) => (i === testimonials.length - 1 ? 0 : i + 1));
  }, []);

  const t = testimonials[currentIndex];

  return (
    <section className="py-16 md:py-20 bg-background-50">
      <div className="w-full max-w-3xl mx-auto px-4 md:px-6 text-center">
        <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-3">
          用户口碑
        </h2>
        <p className="text-foreground-600 text-sm md:text-base mb-10">
          听听用户们怎么说
        </p>

        <div className="relative bg-background-100 rounded-2xl p-6 md:p-10 border border-background-200/60">
          <div className="w-16 h-16 mx-auto mb-4 rounded-full overflow-hidden">
            <img
              src={t.avatar}
              alt={t.name}
              className="w-full h-full object-cover"
            />
          </div>

          <div className="flex items-center justify-center gap-1 mb-3">
            {Array.from({ length: t.rating }).map((_, i) => (
              <i key={i} className="ri-star-fill text-accent-500 text-sm"></i>
            ))}
          </div>

          <blockquote className="text-base md:text-lg text-foreground-700 leading-relaxed mb-5 max-w-xl mx-auto">
            "{t.content}"
          </blockquote>

          <div>
            <strong className="block text-sm font-semibold text-foreground-900">{t.name}</strong>
            <span className="text-xs text-foreground-500">{t.role}</span>
          </div>

          <div className="flex items-center justify-center gap-3 mt-6">
            <button
              onClick={prev}
              className="w-9 h-9 flex items-center justify-center rounded-full bg-background-200 hover:bg-background-300 transition-colors cursor-pointer"
              aria-label="上一条"
            >
              <i className="ri-arrow-left-s-line text-foreground-600"></i>
            </button>
            <div className="flex items-center gap-1.5">
              {testimonials.map((_, i) => (
                <button
                  key={i}
                  onClick={() => setCurrentIndex(i)}
                  className={`w-2 h-2 rounded-full transition-all cursor-pointer ${
                    i === currentIndex ? 'bg-primary-500 w-5' : 'bg-background-300'
                  }`}
                  aria-label={`第${i + 1}条评价`}
                />
              ))}
            </div>
            <button
              onClick={next}
              className="w-9 h-9 flex items-center justify-center rounded-full bg-background-200 hover:bg-background-300 transition-colors cursor-pointer"
              aria-label="下一条"
            >
              <i className="ri-arrow-right-s-line text-foreground-600"></i>
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}